export const ArrowLeft = ({ fill }: { fill: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        style={{ cursor: 'pointer' }}
    >
        <path
            d="M3.3418 9.98698H15.8335"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.3451 4.99365L3.33594 10.0037L8.3451 15.0137"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
